import { selectLocation } from 'bento-ordering/locations/actions/locations';

import {
  OPEN_NOTIFICATION_MODAL,
  CLOSE_NOTIFICATION_MODAL
} from 'bento-ordering/base/actions/actionTypes';

export function openNotificationModal(notificationType, modalProps) {
  return {
    type: OPEN_NOTIFICATION_MODAL,
    payload: { notificationType, modalProps }
  };
}

export function closeNotificationModal() {
  return { type: CLOSE_NOTIFICATION_MODAL };
}

export const handleLocationSwitch = (
  onlineOrderingLocation,
  onlineOrderingFulfillmentMethod
) => async dispatch => {
  dispatch(closeNotificationModal());
  dispatch(
    selectLocation(onlineOrderingLocation, onlineOrderingFulfillmentMethod)
  );
};
